import { useTranslation } from "react-i18next";

const heroBg =
  "https://readdy.ai/api/search-image?query=Modern%20luxury%20steel%20frame%20architecture%20at%20golden%20hour%20with%20dramatic%20sky%2C%20contemporary%20building%20facade%20with%20clean%20geometric%20lines%20and%20warm%20wood%20accents%2C%20floor-to-ceiling%20glass%20windows%2C%20professional%20architectural%20photography%2C%20warm%20cream%20and%20charcoal%20tones%2C%20premium%20editorial%20quality%20with%20soft%20natural%20lighting%20on%20light%20background%2C%20high-end%20residential%20commercial%20building%20exterior%2C%20%20%20&width=1600&height=900&seq=14&orientation=landscape";

export default function HeroSection() {
  const { t } = useTranslation();

  return (
    <section className="relative min-h-[75vh] md:min-h-[80vh] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img src={heroBg} alt="速築美宅家現代建築外觀" className="w-full h-full object-cover object-top" />
        <div className="absolute inset-0 bg-gradient-to-b from-graphite/70 via-graphite/55 to-graphite/80" />
      </div>

      <div className="relative z-10 w-full container-main px-4 md:px-8 lg:px-12 py-28 md:py-36">
        <div className="max-w-3xl">
          <span className="tag-label mb-5 inline-block">{t("about.hero.label")}</span>
          <h1 className="text-white mb-5">{t("about.hero.title")}</h1>
          <p className="text-cream/90 mb-4 max-w-2xl">{t("about.hero.subtitle")}</p>
          <p className="text-champagne text-[1.375rem] md:text-[1.625rem] font-serif font-bold mb-8">
            {t("about.hero.tagline")}
          </p>
          <a
            href="https://lin.ee/OpssTIM"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-primary gap-2 inline-flex"
          >
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-line-fill" />
            </span>
            {t("about.hero.cta")}
          </a>
        </div>
      </div>
    </section>
  );
}